import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing, colors, smallShadow } from 'ui/theme';

const CardContainer = styled.div`
  padding: ${spacing.double};
  ${smallShadow};
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
`;

const StyledSkeleton = styled(Skeleton)`
  :first-child {
    margin-bottom: ${spacing.half};
  }
`;

export const CardSkeleton = () => {
  const shimmerSpeed = 4500;

  return (
    <CardContainer>
      <StyledSkeleton height={20} width={224} shimmerSpeed={shimmerSpeed} />
      <StyledSkeleton height={44} width={160} shimmerSpeed={shimmerSpeed} />
    </CardContainer>
  );
};
